export default function Comparison() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" id="comparison">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-12">
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 font-bold leading-[1.15]">
            <span className="block">Itaobuy</span>
            <span className="block">Spreadsheet</span>
          </h2>
          <p className="text-sm text-foreground-500 max-w-sm lg:text-right lg:pt-3">
            Compare with traditional sourcing methods
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Left Card - Wide */}
          <div className="md:col-span-1 bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <div className="mb-6">
              <div className="space-y-2">
                <div className="h-2 bg-background-200 rounded-full w-full"></div>
                <div className="h-2 bg-background-200 rounded-full w-3/4"></div>
                <div className="h-2 bg-primary-200 rounded-full w-1/2"></div>
                <div className="h-2 bg-background-200 rounded-full w-5/6"></div>
                <div className="h-2 bg-background-200 rounded-full w-2/3"></div>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">Structured Data</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Centralized spreadsheet format with organized product categories, supplier details, and comparison metrics all in one place.
            </p>
          </div>

          {/* Middle Card */}
          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <div className="mb-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-600"></i>
                </div>
                <div className="h-1.5 bg-accent-200 rounded-full flex-1"></div>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">Fast Filtering</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Quickly navigate through categories and filter products by type, saving hours of manual browsing time.
            </p>
          </div>

          {/* Right Card */}
          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <div className="mb-6">
              <div className="flex items-end gap-1.5">
                <div className="w-5 h-12 bg-primary-200 rounded-t-md"></div>
                <div className="w-5 h-20 bg-primary-300 rounded-t-md"></div>
                <div className="w-5 h-28 bg-primary-400 rounded-t-md"></div>
                <div className="w-5 h-36 bg-primary-500 rounded-t-md"></div>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">Scalable System</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Built to grow with your business. Add new categories and products without losing organizational structure.
            </p>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="mt-10 overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-background-300">
                <th className="text-left py-3 px-4 font-semibold text-foreground-950">Feature</th>
                <th className="text-left py-3 px-4 font-semibold text-primary-700 bg-primary-50/50 rounded-t-lg">ItaobuySpreadsheet</th>
                <th className="text-left py-3 px-4 font-semibold text-foreground-600">Traditional Sourcing</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Product Discovery', itaobuy: 'Structured spreadsheet system', traditional: 'Manual search' },
                { feature: 'Speed', itaobuy: 'Fast filtering & categorization', traditional: 'Slow & repetitive' },
                { feature: 'Scalability', itaobuy: 'High', traditional: 'Limited' },
                { feature: 'Beginner Friendly', itaobuy: 'Yes', traditional: 'No' },
                { feature: 'Data Organization', itaobuy: 'Centralized', traditional: 'Scattered' },
              ].map((row, i) => (
                <tr key={i} className="border-b border-background-200/60">
                  <td className="py-3 px-4 font-medium text-foreground-800">{row.feature}</td>
                  <td className="py-3 px-4 text-primary-700 bg-primary-50/30">{row.itaobuy}</td>
                  <td className="py-3 px-4 text-foreground-500">{row.traditional}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}